import React from 'react';
import type { Summary } from '|/app/services';
import MicrOnUs from '|/icons/micr-on-us.svg';
import MicrTransit from '|/icons/micr-transit.svg';
import styles from './checkout-summary.module.css';
import { getAutopaySummary } from './get-autopay-summary';

interface AutopayCheckoutSummaryProps {
  summary: Summary | null;
}

const AutopayCheckoutSummary: React.FC<AutopayCheckoutSummaryProps> = ({ summary }) => {
  const view = getAutopaySummary(summary);

  if (view.kind === 'declined') {
    return <span className={styles.text}>You declined auto pay</span>;
  }

  if (view.kind === 'enrolled') {
    return (
      <div className={styles.container}>
        <span className={styles.text}>You enrolled in auto pay</span>
        {view.accountMask && (
          <span className={styles.row}>
            Account
            <MicrTransit width={9} height={12} aria-hidden="true" />
            &middot;&middot;&middot;&middot;{view.accountMask}
            <MicrOnUs width={9} height={9} aria-hidden="true" />
          </span>
        )}
      </div>
    );
  }

  return null;
};

export default AutopayCheckoutSummary;
